import { useEffect, useState, createRef, PropsWithChildren, FunctionComponent } from "react";
import { Transition } from "react-transition-group";

const TransitionWrapper: FunctionComponent<PropsWithChildren> = ({ children }: PropsWithChildren) => {
  const [inProp, setInProp] = useState<boolean>(false);

  const nodeRef = createRef<HTMLDivElement>();

  useEffect(() => {
    if (nodeRef.current) {
      setInProp(true);
    }
  }, [nodeRef]);

  return (
    <Transition nodeRef={nodeRef} in={inProp} timeout={50} id="transition-wrapper">
      {(state) => (
        <div ref={nodeRef} className={`fade fade-${state}`}>
          {children}
        </div>
      )}
    </Transition>
  );
};

export default TransitionWrapper;
